import { render, staticRenderFns } from "./IntegrationDashboard.vue?vue&type=template&id=481b8975&"
import script from "./IntegrationDashboard.vue?vue&type=script&lang=js&"
export * from "./IntegrationDashboard.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports